import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import "./Card.scss";
import { toast } from "react-toastify";
import { IoIosInformationCircleOutline } from "react-icons/io";

const Card = ({ item }) => {
  const dispatch = useDispatch();
  const cartItem = useSelector((state) =>
    state.cart.products.find((i) => i.id === item.id)
  );
  const quantity = cartItem?.quantity || 0;

  const handleAddToCart = () => {
    if (item.outofstock) {
      toast.error("This product is unavailable");
      return;
    }

    // 1️⃣ Redux add to cart
    dispatch(
      addToCart({
        id: item._id,
        name: item.name,
        desc: item.desc,
        weight: item.weight,
        price: item.price,
        stock: item.stock,
        img: item.proPhotos[0],
        quantity: 1,
      })
    );
    toast.success("Added to cart!");

    // 2️⃣ Google Analytics (GA4) event
    if (window.gtag) {
      window.gtag("event", "add_to_cart", {
        currency: "AED",
        value: item.price,
        items: [
          {
            item_id: item._id,
            item_name: item.name,
            price: item.price,
            quantity: 1,
          },
        ],
      });
    }

    // 3️⃣ Meta Pixel event
    if (window.fbq) {
      window.fbq("track", "AddToCart", {
        value: item.price,
        currency: "AED",
        contents: [
          {
            id: item._id,
            quantity: 1,
            item_name: item.name,
          },
        ],
        content_type: "product",
      });
    }
  };

  return (
    <div className="card">
      <div className="image-wrapper">
        <span className="badge discount">{item.discount}%</span>
        {item.outofstock && <span className="badge out">Out of Stock</span>}

        <img
          src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[0]}`}
          alt={item.name}
          className="mainImg"
        />
        <img
          src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[1]}`}
          alt={item.name}
          className="hoverImg"
        />
      </div>

      <div className="card-content">
        <h3 className="title">{item.name}</h3>
        <p className="weight">Weight: {item.weight}</p>
        <div className="bt_wrp">
          <div className="price-section">
            {item.oldPrice && (
              <span className="old-price">
                <em>AED </em>
                {item.oldPrice}
              </span>
            )}
            <span className="price">
              <em>AED</em> {item.price}
            </span>
          </div>

          <button
            className="add-btn"
            onClick={handleAddToCart}
            disabled={item.outofstock}
          >
            {item.outofstock ? "Unavailable" : "Add to Cart"}
          </button>
        </div>

        {item.outofstock ? (
          <Link className="learn-more">
            <IoIosInformationCircleOutline size={17} color="white" />
          </Link>
        ) : (
          <Link to={`/product/${item.slug}`} className="learn-more">
            <IoIosInformationCircleOutline size={17} color="gray" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default Card;
